<template>
<div>
  <van-notice-bar
    wrapable
    :scrollable="false"
    :text="'二维码审核中，您还可预览 '+ (100 - config.qrData.views_today)+' 次，审核后不限次数。'"
    v-if="config.qrData.status==0"
    class="qr-status_msg"
  ></van-notice-bar>

  <div v-if="pluginList.length<=0">
    <van-empty description="本页面暂无数据" />
  </div>

  <van-form validate-first @submit="onSubmit" @failed="onFailed">
    <div v-for="( element, pluginIndex) in pluginList" :key="'plugin-'+pluginIndex" :id="'plugin-'+pluginIndex"  :style="(pluginIndex==0 && element.name=='navBar') ? 'z-index:100' : ''">
        <template v-if="RenderPlugins[element.name]">
            <!-- 动态加载组件 -->
            <component :is="RenderPlugins[element.name]" :schema="element" :pluginIndex="pluginIndex"></component>
        </template>
        <template v-else>
            <div class="block-title">
                组件：{{element.name}}
                <div class="block-desc">请适配此组件，否则无法正常显示</div>
            </div>
        </template>
    </div>
  </van-form>
</div>
</template>

<script>
import { mapState } from 'vuex'
// import draggable from 'vuedraggable';
// import _ from 'lodash'
// import utils from '../utils/utils'
import RenderPlugins from './plugins/index';
import { Dialog,Toast } from 'vant';

export default {
  name: 'Simulator',
  props: {
    // msg: String
  },
  components: {
  },
  data:function() {
    return {
     RenderPlugins,
     submitDisabled:false
    }
  },
  computed:{
    ...mapState(['config','submitPluginIndex','formSubmitPwd']),
    // 需要拖动进行 set
    pluginList:{
        get: function () {
            return this.$store.state.pluginList
        },
        set: function (newValue) {
            this.$store.commit('setPluginList',newValue)
        }
    }
  },
  mounted:function(){
    this.$nextTick(() => {
      this.init();
    });
	},
  methods:{
    init:function(){
      var that =this;
      //防重复1天内
      var ymdCache = localStorage.getItem('notRepeat_'+ this.config.qrScene);
      // console.log(timestampCache);
      var ymd = that.getYmd();
      if(ymd ==ymdCache){
         that.submitDisabled = true;
      }
 
		},
    getYmd :function(){
        let date = new Date()
        let Str =date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
      return Str;
    },
    actionPlugin(){
      // console.log('actionPlugin',this.submitPluginIndex)
      this.$store.commit('actionPlugin',{
        pluginIndex:this.submitPluginIndex
      })
    },
    onSubmit(formValues){
      var that = this;
      // console.log('formValues',this.submitPluginIndex,formValues)

      if(this.config.isNotRepeat && this.submitDisabled){
        Dialog.alert({
          title: '提示',
          message:'您已经提交过，不要重复提交',
        }).then(() => {
          // on close
        }).catch(() => { });

        return false;
      }


      Dialog.confirm({
        title: '确认提交',
        message: '您确定要提交吗？',
      })
      .then(() => {
        // on confirm
        that.confirmSubmit(formValues);
      })
      .catch(() => {
        // on cancel
      });

    },
    onFailed:function(errorInfo){
      
      if(errorInfo.errors && errorInfo.errors[0]){
        Dialog.alert({
          title: '提示',
          message: errorInfo.errors[0].message || "操作错误，请重试",
          closeOnClickOverlay:true
        }).then(() => {
          // on close
        }).catch(() => { });
      }

    },
    confirmSubmit:function(formValues) {
      // console.log('formValues', this.pluginList,formValues)
      var that = this;

      var submitPluginData = that.pluginList[that.submitPluginIndex];//提交按钮  formName
      var formData = [];

      for(var index in this.pluginList){
        var plugin = this.pluginList[index];
        if(typeof(plugin.uniqid) != 'undefined' && plugin.name !='submit' && plugin.name !='formData' && submitPluginData.formName == plugin.formName){
       
          var key  = plugin.name +'_'+ plugin.uniqid;
          // console.log(key,formValues[key])
          var _value;
          if(plugin.name=='imgUploader'){
            var _fileList = formValues[key];
            _value = [];
            for(var i in _fileList){
              _value.push({
                url: _fileList[i].url,
                name: _fileList[i].name,
                size: _fileList[i].size,
                attach_scene: _fileList[i].attach_scene,
              });
            }
            
          }else if (plugin.name=='location'){
            _value = plugin.location;
            
          }else if (plugin.name=='mapMarked'){
            _value = plugin.marked;
          }else if (plugin.name=='radioGroup'){
            _value = formValues[key];
            // 其他替换为值
            if(_value=='其他'){
               _value = formValues[key+'_other'] || '';
            }
          }else if (plugin.name=='checkboxGroup'){
            _value = formValues[key];
            // 其他替换为值
            var _otherIndex = _value.findIndex((item)=>item=='其他')
            if(_otherIndex !==-1){
               _value[_otherIndex] = formValues[key+'_other'] || '';
            }
          }else if (plugin.name=='tableField' || plugin.name=='checkList'){
            _value = plugin.items;
          }else if (plugin.name=='formStatus'){
            _value = plugin.working;
          }else{
            // default
            _value = formValues[key] || '';
          }
      
          formData.push({
              name:plugin.name,
              uniqid:plugin.uniqid,
              formName:plugin.formName,
              value:_value,
              label:plugin.label
            });

        }
      }

      // console.log('formData',formData)
      // return ;

  

      if(formData.length<=0){
        Dialog.alert({
          title: '提示',
          message:'表单中暂无可提交内容',
          closeOnClickOverlay:true
        }).then(() => {
          // on close
        }).catch(() => { });

        return false;
      }

      this.$http.post( config.apiDomain + '/diy/form_save.html', {
        qr_scene:config.qrScene,
        tb_scene:config.tbScene,
        submit_pwd:that.formSubmitPwd,
        form_name:submitPluginData.formName,
        form_data:JSON.stringify(formData)
      },{emulateJSON:true}).then(function (response) {
          var res = response.data;
          if(res.code ==1){
            // console.log(res);

            //保存成功后的一些动作
            if(that.submitPluginIndex !=null){
              //防重复开启
              if(that.isNotRepeat || submitPluginData.notRepeat){
                that.submitDisabled = true;
                localStorage.setItem('notRepeat_'+config.qrScene,that.getYmd());
              }

              if(submitPluginData.handle=="link"){
                Toast.success(res.msg);
                setTimeout(function(){
                  that.actionPlugin();
                },800);
              }else{
                that.actionPlugin();
              }
              
            }
            

          }else{
            Dialog.alert({
              title: '提示',
              message: res.msg,
              closeOnClickOverlay:true
            }).then(() => {
              // on close
            }).catch(() => { });

          }
      }).catch(function (error) {
        console.log(error);
          Dialog.alert({
            title: '提示',
            message: '请求发生错误，请稍后再试',
            closeOnClickOverlay:true
          }).then(() => {
            // on close
          }).catch(() => { });
      });
      
    }


  }
}
</script>

<style>
.qr-status_msg{
  z-index: 10;
  position:fixed !important;
  top:0;
  width: 100%;
}
/* 模拟手机 */
 .form-title{
    font-size: 16px; 
    color:var(--van-blue);
    padding:10px;
    font-weight: bold;
    border:1px solid #f1f1f1;

}
.form-title:hover{
	border:1px dashed #409EFF;
    z-index: 1;
}

.form-desc{
    font-size: 14px; 
    color: var(--van-gray-6);
    font-weight: 400; 
    margin-top:5px;
}
.block-title{
  margin: 0;
  padding: 16px;
  color:#323233;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  background: #e4e7ea;

}
.block-title--required:before {
  margin-right: 2px;
  color: #ee0a24;
  content: "*";
}
.block-desc{
  font-size: 14px;
  color: #969799;
  font-weight: 400;
  margin-top:5px;
}
/* ueditor表格默认样式 */
.table{border-collapse:collapse}.table-bordered td,.table-bordered th{border:1px solid #ddd}
.table-statis{
	color: #666;
}
.table-statis-success{
	color: #07c160;
}
.table-statis-warning{
	color: #ee0a24;
}



/* 参考 nutui table */
.van-table {
  display: flex;
  width: 100%;
  flex-direction: column;
  font-size: 14px;
}
.van-table__main {
  display: table;
  width: 100%;
  border-collapse: collapse;
  overflow-x: hidden;
}
.van-table__main__body {
  display: table-row-group;
}
.van-table__main__head__tr, .van-table__main__body__tr {
  display: table-row;
}
.van-table__main--striped .van-table__main__body__tr:nth-child(odd) {
  background-color: #fff;
}
.van-table__main__head__tr--alignleft, .van-table__main__head__tr--align, .van-table__main__body__tr--alignleft, .van-table__main__body__tr--align {
  text-align: left;
}
.van-table__main__head__tr--border, .van-table__main__body__tr--border {
  border: 1px solid #dadada;
}
.van-table__main__head__tr__th, .van-table__main__body__tr__th, .van-table__main__head__tr__td, .van-table__main__body__tr__td {
  display: table-cell;
  padding: 10px;
}
.van-table__main--striped .van-table__main__body__tr:nth-child(even) {
  background-color: #f2f3f5;
}

.van-table .van-field{
padding: 5px !important;
border: 1px solid #999999 !important;
}
.van-table .van-table__summary {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 30px;
  padding: 10px;
}
.van-table .van-table__summary__text{
color: #909ca4;
margin-left: 10px;
}
</style>
